import PageTitle from '../../components/page-title';
import CreatorRanking from './creator-ranking';
import AgencyRanking from './agency-ranking';

const RevenueManager = () => (
  <div>
    <PageTitle title="Bảng xếp hạng" />
    <CreatorRanking />
    <AgencyRanking />
  </div>
);

export default RevenueManager;
